import { IReview } from "@Interfaces/Api/Review";
import { Icon, Typography, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Rating from "@mui/material/Rating";
import { StyledYellowBox } from "@Styled/Pages/Category";
import {
  StyledComment,
  StyledReviewDate,
  StyledReviewerName,
} from "@Styled/Pages/ProductDetails";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";

interface ReviewProps {
  review?: IReview[];
  pendingApprovalReview?: IReview;
  handleEditReview: Function;
  myReview: IReview;
}
export default function Review({
  review,
  pendingApprovalReview,
  handleEditReview,
  myReview,
}: ReviewProps) {
  const myReviewDate = new Date(
    pendingApprovalReview ? pendingApprovalReview?.updatedAt : ""
  );
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Box sx={{ marginBottom: "1rem" }}>
      {pendingApprovalReview && (
        <>
          <Divider
            variant="fullWidth"
            sx={{
              margin: "0.5rem 0rem 1rem 0rem",
              width: { xs: "100%" },
              height: "1px",
              background: theme.palette.secondary.main,
            }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginTop: "1rem",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
              }}
            >
              <Icon
                component={EditIcon}
                style={{ fontSize: "1.2rem", cursor: "pointer" }}
                onClick={() => handleEditReview()}
              />

              <Rating
                name="read-only"
                value={pendingApprovalReview.rating}
                readOnly
                sx={{
                  marginBottom: "0.5rem",
                  paddingRight: "0.3rem",
                }}
                color={"green"}
              />
              {isDesktop ? (
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  style={{ marginTop: "2px" }}
                />
              ) : (
                ""
              )}

              <Typography sx={{ paddingLeft: { sm: "5px", xs: "" } }}>
                {pendingApprovalReview?.title}
              </Typography>
            </Box>
            <StyledYellowBox variant="h6">
              {pendingApprovalReview.status == "PENDING" ? (
                <span>Pending approval</span>
              ) : (
                <span> Rejected </span>
              )}
            </StyledYellowBox>
          </Box>
          <StyledComment>{pendingApprovalReview.message}</StyledComment>

          <Box
            sx={{ display: "flex", alignItems: "center", marginTop: "1rem" }}
          >
            <StyledReviewerName
              sx={{ paddingRight: "0.5rem" }}
            >{`${pendingApprovalReview.user.name}`}</StyledReviewerName>
            <Divider orientation="vertical" flexItem variant="middle" />
            <StyledReviewDate sx={{ padding: "0.5rem" }}>
              {moment(myReviewDate).format("Do MMMM YYYY")}
            </StyledReviewDate>
          </Box>
        </>
      )}

      {review &&
        review.map((review) => {
          const reviewDate = new Date(review ? review?.updatedAt : "");
          return (
            <>
              <Divider
                variant="fullWidth"
                sx={{
                  margin: "0.5rem 0rem 1rem 0rem",
                  width: { xs: "100%" },
                  height: "1px",
                  background: theme.palette.secondary.main,
                }}
              />

              <Box style={{ display: "flex" }}>
                {myReview && myReview._id == review._id && (
                  <Icon
                    component={EditIcon}
                    style={{ fontSize: "1.2rem", cursor: "pointer" }}
                    onClick={() => handleEditReview()}
                  />
                )}
                <Rating
                  name="read-only"
                  value={review.rating}
                  readOnly
                  sx={{
                    marginBottom: "0.5rem",
                    paddingRight: "0.3rem",
                  }}
                  color={"green"}
                />
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  style={{ marginTop: "2px" }}
                />

                <Typography style={{ paddingLeft: "5px" }}>
                  {review?.title}
                </Typography>
              </Box>
              <StyledComment>{review.message}</StyledComment>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1rem",
                }}
              >
                <StyledReviewerName
                  sx={{ paddingRight: "0.5rem" }}
                >{`${review.user.name}`}</StyledReviewerName>
                <Divider orientation="vertical" flexItem variant="middle" />
                <StyledReviewDate sx={{ padding: "0.5rem" }}>
                  {moment(reviewDate).format("Do MMMM YYYY")}
                </StyledReviewDate>
              </Box>
            </>
          );
        })}
    </Box>
  );
}
